/*
$('.select-medida').hide();
$('.select-segmento').hide();
$('.select-modelo').hide();
$('.select-marca').hide();
*/
$('.busqueda-marca').change(function() {
 /*   var selectedUrl = $(this).val();
    $('.btnBuscar').attr('href', selectedUrl);*/
  });

  $(".btn-mostrar-busqueda").on("click", function(){
    $(".contenedor-busqueda").show();
  })
  $(".content-ocultar-busqueda button").on("click", function(){
    $(".contenedor-busqueda").hide();
  })

 const actualizarLink = () => {
            console.log("actualizar link")
            const medida = $('#select-medida').val();
            const segmento = $('#select-segmento').val();
            const marca = $('#select-marca').val();
            const modelo = $('#select-modelo').val();
   
            const medida_m = $('#select-medida_m').val();
            const segmento_m = $('#select-segmento_m').val();
            const marca_m = $('#select-marca_m').val();
            const modelo_m = $('#select-modelo_m').val();

            const linkBase = 'https://grupovegamx.myshopify.com/search?q=';
            const query = [];
            const query_m = [];

            // if (medida && medida !== '0') query.push(`tag:${medida}`);
            // if (segmento && segmento !== '0') query.push(`tag:${segmento}`);
            // if (marca && marca !== '0') query.push(`tag:${marca}`);
            // if (modelo && modelo !== '0') query.push(`tag:${modelo}`);
   
            // if (medida_m && medida_m !== '0') query_m.push(`tag:${medida_m}`);
            // if (segmento_m && segmento_m !== '0') query_m.push(`tag:${segmento_m}`);
            // if (marca_m && marca_m !== '0') query_m.push(`tag:${marca_m}`);
            // if (modelo_m && modelo_m !== '0') query_m.push(`tag:${modelo_m}`);
 
            if (medida && medida !== '0') query.push(`${medida}`);
            if (segmento && segmento !== '0') query.push(`${segmento}`);
            if (marca && marca !== '0') query.push(`${marca}`);
            if (modelo && modelo !== '0') query.push(`${modelo}`);
   
            if (medida_m && medida_m !== '0') query_m.push(`${medida_m}`);
            if (segmento_m && segmento_m !== '0') query_m.push(`${segmento_m}`);
            if (marca_m && marca_m !== '0') query_m.push(`${marca_m}`);
            if (modelo_m && modelo_m !== '0') query_m.push(`${modelo_m}`);
 
            const link = linkBase + query.join('+');
            const link_m = linkBase + query_m.join('+');  
             $('#btnBuscar').attr('href', link);
             $('#btnBuscar_m').attr('href', link_m);
 
        };
/*
$('#buscar').on('click', function () {
    const link = $('#shopify-link').attr('href');
    window.open(link, '_blank');
});*/


   $(function () {
            // Cargar el archivo Excel automáticamente al cargar la página
            //leerArchivoJS('https://cdn.shopify.com/s/files/1/0870/5625/3213/files/Lista_de_vehiculos_JSON.csv?v=1721081573');
            leerArchivoJS('https://cdn.shopify.com/s/files/1/0870/5625/3213/files/Lista_de_vehiculos.xlsx?v=1721082186');

            $('.select-medida').on('change', function () {
                actualizarSelect('SEGMENT', '.select-segmento', 'MEDIDA', $(this).val());
              $('.select-segmento').val(0)
              $('.select-marca').val(0)
              $('.select-modelo').val(0)
              actualizarLink();
            });

            $('.select-segmento').on('change', function () {
                actualizarSelect('MARCA', '.select-marca', 'SEGMENT', $(this).val());
              $('.select-marca').val(0)
              $('.select-modelo').val(0)
              actualizarLink();
            });

            $('.select-marca').on('change', function () {
                actualizarSelect('MODELO', '.select-modelo', 'MARCA', $(this).val());
              $('.select-modelo').val(0)
              actualizarLink();
            });
            $('.select-modelo').on('change', function () {
                actualizarLink();
            });
        });

        let datosExcel = [];

        const leerArchivoJS = async (filePath) => {
            try {
                const response = await fetch(filePath);
                const data = await response.arrayBuffer();
                const workbook = XLSX.read(data, { type: 'array' });

                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                datosExcel = XLSX.utils.sheet_to_json(sheet);

                //llenarSelectMedida();
              llenarSelectMarca();
            } catch (e) {
                console.error(e);
            }
        };

        const llenarSelectMedida = () => {
            const medidas = [...new Set(datosExcel.map(dato => dato.MEDIDA))];
            const selectMedida = $('.select-medida');

            medidas.forEach(medida => { 
              //$("body").append(medida+"<br>")
                selectMedida.append(`<option value="${medida}">${medida}</option>`);
            });
        };

        const llenarSelectMarca = () => {
            const medidas = [...new Set(datosExcel.map(dato => dato.MARCA))];
            const selectMarca = $('.select-marca');

            medidas.forEach(medida => {
                selectMarca.append(`<option value="${medida}">${medida}</option>`);
            });
        };


        const actualizarSelect = (campo, selectId, filtroCampo, filtroValor) => { 
            const datosFiltrados = datosExcel.filter(dato => dato[filtroCampo] === filtroValor);
            const valores = [...new Set(datosFiltrados.map(dato => dato[campo]))];
            const select = $(selectId); 
            select.empty();
            select.append(`<option value="0">Seleccione ${campo}</option>`);
            valores.forEach(valor => {
                select.append(`<option value="${valor}">${valor}</option>`);
            });
        };

$('.select-medida').hide();
$('.select-segmento').hide();